/* One source for the sidebar's width.
   The drawer said 248 and the layout that offsets the content said 200, so
   48px of every dashboard page sat underneath the sidebar. */
export const SIDEBAR_WIDTH = 248;
export const SIDEBAR_WIDTH_COLLAPSED = 76;
